export default (initialState = {}) => {
  return () => {
    return {
      buyer_name: "",
      buyer_gstin: "",
      date: null,
      dispatch_address: "",
      dispatch_address_info: {},
      invc_number: "",
      number: "",
      po_info: {},
      shipping_address: "",
      shipping_address_info: {},
      status_cd: "active",
      total_amount: null,
      vehicle_number: "",
      ...initialState,
    };
  };
};
